import { render, staticRenderFns } from "./IssueEditModal.vue?vue&type=template&id=6a9beae0&"
import script from "./IssueEditModal.vue?vue&type=script&lang=js&"
export * from "./IssueEditModal.vue?vue&type=script&lang=js&"
import style0 from "./IssueEditModal.vue?vue&type=style&index=0&id=6a9beae0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports